import { Checkbox, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { Banner } from "components/common/Banner";
import { useStageConfig } from "in_queue/contexts/ClusterContext";
import { formatPower } from "in_queue/utils/formatting";
import { ProjectSizeAssumptionsMetadata } from "../ScenarioBuilder/scenarioBuilder.helpers";
import css from "./ScenarioPreviewBanner.module.scss";

interface ScenarioPreviewBannerProps {
    projectSizeAssumptionsMetadata: ProjectSizeAssumptionsMetadata;
    isWarningAcknowledged: boolean;
    setIsWarningAcknowledged: (newValue: boolean) => void;
}

export const ScenarioPreviewBanner: React.FC<ScenarioPreviewBannerProps> = ({
    projectSizeAssumptionsMetadata: {
        droppedProjectCount,
        downsizedProjectCount,
        mwRemoved,
        percentageMwRemoved
    },
    isWarningAcknowledged,
    setIsWarningAcknowledged
}) => {
    const stageConfig = useStageConfig();

    if (percentageMwRemoved === 0.0) {
        return null;
    }

    const shouldShowSubmitWarning =
        percentageMwRemoved > stageConfig.maxMwPercentageRemoved;

    return (
        <Banner
            intent={shouldShowSubmitWarning ? Intent.WARNING : Intent.PRIMARY}
            icon={
                shouldShowSubmitWarning
                    ? IconNames.WARNING_SIGN
                    : IconNames.INFO_SIGN
            }
            title={`This scenario adjusts ${(percentageMwRemoved * 100).toFixed(
                1
            )}% of the queue`}
            description={
                <>
                    <b>{droppedProjectCount}</b> projects dropped and{" "}
                    <b>{downsizedProjectCount}</b> projects downsized, removing{" "}
                    <b>{formatPower(mwRemoved)}</b> of generation from the
                    model.
                    {shouldShowSubmitWarning && (
                        <>
                            {" "}
                            Scenarios that drop more than{" "}
                            {stageConfig.maxMwPercentageRemoved * 100}% of
                            projects will likely fail due to issues with
                            redispatching large amounts of generation.
                            <Checkbox
                                className={
                                    css["ScenarioPreviewBanner-acknowledge"]
                                }
                                checked={isWarningAcknowledged}
                                label="Acknowledge"
                                onChange={() =>
                                    setIsWarningAcknowledged(
                                        !isWarningAcknowledged
                                    )
                                }
                            />
                        </>
                    )}
                </>
            }
        />
    );
};
